import React from 'react';

import { ReactComponent as InfoIcon } from '@assets/svg/executive-summary/ic-info.svg';

import ColorBlock from '@components/common/ColorBlock/ColorBlock';

import useTranslation from '@hooks/useTranslation';

import type {
  IActionItemsStatusesCount,
  IActionItemsStatusesWithColor,
  TActionItemsStatusesKey,
} from '../../model/actionItemsStatuses';
import style from './style.module.scss';

interface IProps {
  data: {
    statuses: Array<IActionItemsStatusesWithColor>;
    statusValues: Record<TActionItemsStatusesKey, IActionItemsStatusesCount>;
    total: number;
  };
  name: string;
  color: string;
}

const ActionItemsLegend: React.FC<IProps> = ({ data, name, color }) => {
  const { t } = useTranslation();
  const { statuses, statusValues, total } = data;

  const getTooltipData = <T extends { key: TActionItemsStatusesKey }>(
    statuses: T[],
    statusValues: Record<TActionItemsStatusesKey, IActionItemsStatusesCount>,
    total: number,
  ) => {
    return {
      status: name,
      data: statuses.map((item) => {
        const value = statusValues[item.key].count;
        return {
          ...item,
          total: value,
          percent: Math.round(((value * 100) / total) * 100) / 100,
        };
      }),
    };
  };

  return (
    <div className={style.legendLabel}>
      <ColorBlock color={color as string} width={14} height={14} />
      <span>{t(name)}</span>
      <InfoIcon
        data-tooltip-id="action-items-legend-tooltip"
        data-tooltip-content={JSON.stringify(getTooltipData(statuses, statusValues, total))}
      />
    </div>
  );
};

export default ActionItemsLegend;
